import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgxDropzoneComponent } from 'ngx-dropzone';

import { FileUpload } from '@classes/file/file-upload';
import { FileInfo } from '@classes/file/file-info';
import { FileService } from '@services/file.service';
import { UiService } from '@services/ui.service';
import { UploadStatus } from '@enums/upload-status.enum';
import { UploadBaseComponent } from '../upload-base/upload-base.component';

@Component({
    selector: 'app-upload-multi',
    templateUrl: './upload-multi.component.html',
    styleUrls: ['./upload-multi.component.scss']
})
export class UploadMultiComponent extends UploadBaseComponent implements OnInit, OnDestroy {
    @ViewChild('dropzone', { static: true }) dropzone: NgxDropzoneComponent;

    files: FileUpload[];
    filesInfo: FileInfo[];

    constructor(
        fileSrv: FileService,
        private uiSrv: UiService
    ) {
        super(fileSrv);

        this.files = []; // local uploading files array
        this.filesInfo = [];
    }

    ngOnInit() {
    }

    onAddFiles(files: File[]): void {
        this.files.push(...files.map(file => new FileUpload(file)));
        // Clean up dropzone to avoid duplicate files on next selection
        this.dropzone.reset();
    }

    onRemoveFile(index: number): void {
        this.files.splice(index, 1);
    }

    onRemoveAll(): void {
        this.files = [];
        this.filesInfo = [];
    }

    onUploadAll(): void {
        this.isUploading = true;
        // Send all files to api and track progress in files list
        const uploadPromise = this.files.map((file, index) => {
            return new Promise((resolve, reject) => {
                return this.fileSrv.uploadWithProgress(file)
                .subscribe(res => {
                    this.files[index] = res;

                    if(res.fileInfo == null) {
                        this.files[index].status = UploadStatus.uploading;
                    } else {
                        this.files[index].status = UploadStatus.done;
                        this.filesInfo.push(res.fileInfo);
                        return resolve(res);
                    }
                }, err => {
                    if (err.error.error === 'invalid_type')
                        this.files[index].status = UploadStatus.invalidType;
                    else
                        this.files[index].status = UploadStatus.fail;
                    return reject(err);
                });
            });
        });

        // When all files are sent, emit all fileInfo
        Promise.all(uploadPromise).then(() => this.afterUpload(), () => this.afterUpload());
    }

    private afterUpload(): void {
        if (this.files.length === this.filesInfo.length) {
            this.afterFilesUpload.emit(this.filesInfo);
            this.onRemoveAll();
        } else {
            this.uiSrv.showSnackbar(this.uiSrv.translate('files.processingStates.fail.summary'), null);
        }

        this.isUploading = false;
    }
}
